export const LOCAL_STORAGE_AUTH_CHECK_KEY = `@mst/login`;

// kenny: 로컬에서는 매번 로그인 시마다 Application > Cookies에서 받아와서 넣어줘야 함
//        정확한 이유는 모르는데, 쿠키 설정 중 HttpOnly, Same-Origin, Secure 옵션과 관련이 있는 듯
export const LOCAL_CSRF_TOKEN = "G3iYdcRQySlnQ8p7msGa5NbUYRuH8qN3yuQbjJKlxwSvdsLe4LOJPKOOmLI1N4G6";
